import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { MatDialogModule } from '@angular/material/dialog';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { register } from 'swiper/element/bundle';
import { SwiperDirective } from './directives/swiper.directive';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { CardSkeletonComponent } from './components/skeletons/card-skeleton/card-skeleton.component';
import { InfoSkeletonComponent } from './components/skeletons/info-skeleton/info-skeleton.component';
import { SmartphotoListComponent } from './pages/smartphoto-list/smartphoto-list.component';
import { SmartphotoCardComponent } from './pages/smartphoto-list/smartphoto-card/smartphoto-card.component';
import { SmartphotoDetailComponent } from './pages/smartphoto-detail/smartphoto-detail.component';
import { SmartphotoPicturesComponent } from './pages/smartphoto-detail/smartphoto-pictures/smartphoto-pictures.component';
import { SmartphotoInfoComponent } from './pages/smartphoto-detail/smartphoto-info/smartphoto-info.component';
import { SmartphotoCreateComponent } from './pages/smartphoto-create/smartphoto-create.component';
import { LogOutDialog } from './components/navbar/dialog/dialog.component';
import { SmartphotoPicturesGalleryDialog } from './pages/smartphoto-detail/smartphoto-pictures/smartphoto-pictures-gallery/smartphoto-pictures-gallery-dialog.component';
import { AngularI18nModule } from '@bdeo-motor/angular-i18n';
import { I18NEXT_NAMESPACE } from 'angular-i18next';
import '@lottiefiles/lottie-player';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { SetPaddingBottomDirective } from './directives/set-padding-bottom.directive';
import { SmartphotoDamageEstimationListComponent } from './pages/smartphoto-detail/smartphoto-damage-estimation-list/smartphoto-damage-estimation-list.component';
import { SmartphotoDamageEstimationCardComponent } from './pages/smartphoto-detail/smartphoto-damage-estimation-list/smartphoto-damage-estimation-card/smartphoto-damage-estimation-card.component';
import { UpwardAccordionComponent } from './components/upward-accordion/upward-accordion.component';
import { SmartphotoDamageEstimationDrawerComponent } from './pages/smartphoto-detail/smartphoto-damage-estimation-list/smartphoto-damage-estimation-drawer/smartphoto-damage-estimation-drawer.component';
import { SmartphotoBasketEditDrawerComponent } from './pages/smartphoto-detail/smartphoto-info/smartphoto-basket-edit-drawer/smartphoto-basket-edit-drawer.component';
import { SmartphotoFooterComponent } from './pages/smartphoto-detail/smartphoto-footer/smartphoto-footer.component';
import { SmartphotoDamageEstimationPriceDrawerComponent } from './pages/smartphoto-detail/smartphoto-damage-estimation-list/smartphoto-damage-estimation-price-drawer/smartphoto-damage-estimation-price-drawer.component';
import { SmartphotoSendReportDrawerComponent } from './pages/smartphoto-detail/smartphoto-footer/smartphoto-send-report-drawer/smartphoto-send-report-drawer.component';
import { SmartphotoReviewDrawerComponent } from './pages/smartphoto-review-drawer/smartphoto-review-drawer.component';
import { EmailChipInput } from './components/email-chip/email-chip-input.component';
import { MatChipsModule } from '@angular/material/chips';
import { FieldWriteRadioListComponent } from './components/radio-list-input/field-write-radioList.component';
import { SmartphotoDamageActionsComponent } from './pages/smartphoto-detail/smartphoto-footer/smartphoto-damage-actions/smartphoto-damage-actions.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { TermsAndConditionsDialogComponent } from './components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';

try {
  import('@bdeo/webcomponents').then(({ setLocale }) => {
    try {
      const language = localStorage.getItem('language') || 'en-US';
      setLocale(language);
      window.addEventListener('languageChanged', (event: Event) => {
        if (!(event instanceof CustomEvent)) {
          return;
        }
        try {
          setLocale(event.detail.language);
        } catch {
          console.log(`[WARNING] Invalid language ${event.detail.language} specified, default to english`);
        }
      });
    } catch (err) {
      console.log('[WARNING] Error occurred while loading languages ', err);
    }
  });
} catch (err) {
  console.log('[WARNING] Error occurred while loading webcomponents ', err);
}

registerLocaleData(localeEs, 'es');

// Swiper
register();

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    UpwardAccordionComponent,
    EmailChipInput,
    FieldWriteRadioListComponent,
    SmartphotoListComponent,
    SmartphotoInfoComponent,
    SmartphotoDetailComponent,
    SmartphotoCardComponent,
    SmartphotoDamageEstimationListComponent,
    SmartphotoDamageEstimationCardComponent,
    SmartphotoDamageEstimationDrawerComponent,
    SmartphotoDamageEstimationPriceDrawerComponent,
    SmartphotoBasketEditDrawerComponent,
    SmartphotoSendReportDrawerComponent,
    SmartphotoFooterComponent,
    SmartphotoDamageActionsComponent,
    SmartphotoReviewDrawerComponent,
    TermsAndConditionsComponent,
    TermsAndConditionsDialogComponent,
    CardSkeletonComponent,
    InfoSkeletonComponent,
    SmartphotoPicturesComponent,
    SmartphotoCreateComponent,
    LogOutDialog,
    SmartphotoPicturesGalleryDialog,
    SwiperDirective,
    SetPaddingBottomDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatChipsModule,
    AngularI18nModule.forRoot(),
    AngularI18nModule,
    MatChipsModule
  ],
  providers: [
    provideAnimationsAsync(),
    {
      provide: I18NEXT_NAMESPACE,
      useValue: 'brokers'
    },
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
